import { useRef, useEffect } from "react";
import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { Box as MuiBox, Button as MuiButton } from "@mui/material";
import styled from "@emotion/styled";

const Box = styled(MuiBox)`
  &.container {
    width: 100%;
    height: 100%;
  }

  &.input-container {
    width: 75vw;
  }
`;

const Button = styled(MuiButton)`
  &.next-button {
    width: 25vw;
    height: 10vh;
    font-size: 40px;
  }
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  font-size: 5vw;
  font-weight: bold;
  border: none;

  &::placeholder {
    color: #f1f1f1;
  }
`;

const Title = styled.div`
  font-size: 2.5vw;
  font-weight: bold;
`;

const Span = styled.span`
  font-weight: 800;
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 5vw;
`;

interface LandscapeNameInputProps {
  onClickNext: () => void;
}

export const LandscapeNameInput = ({
  onClickNext,
}: LandscapeNameInputProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const { name, setName } = useSimpleRegistrationContext();

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <Box className="container">
      <Title>
        <Span>이름</Span>을 입력하세요.
      </Title>
      <InputWrapper>
        <Box className="input-container">
          <Input
            ref={ref}
            placeholder="홍길동"
            value={name}
            onChange={(e) => {
              const input = e.target.value;
              let maxChars;

              if (/^[a-zA-Z]*$/.test(input)) {
                maxChars = 32;
              } else {
                // 입력이 한글일 경우
                maxChars = 16;
              }

              if (input.length > maxChars) {
                e.target.value = input.slice(0, maxChars);
              }
              setName(e.target.value);
            }}
          />
        </Box>
        <Button
          className="next-button"
          variant="contained"
          disabled={name.length < 2}
          onClick={() => onClickNext()}
        >
          다음
        </Button>
      </InputWrapper>
    </Box>
  );
};
